module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-14-1eb2491dee969471c763ef6104b47fb2.jpg";